// Canonical stage data: the 12 stages we display, their colors (tuned for white-text
// readability at night), and the EDC-style word splits for column headers.

export const MAIN_STAGES = [
  "Kinetic Field",
  "Circuit Grounds",
  "Cosmic Meadow",
  "Neon Garden",
  "Basspod",
  "Wasteland",
  "Quantum Valley",
  "Stereo Bloom",
  "Bionic Jungle",
  "Forest House",
  "YeeDC!",
  "Insomniac Fridays",
] as const;

export type MainStage = typeof MAIN_STAGES[number];

// All ≥ 4.3:1 contrast against white. Three are user-anchored
// (orange Kinetic, red Wasteland, green Meadow); the rest fan out
// across the rainbow with deep saturated low-luminance hues.
export const STAGE_COLORS: Record<string, string> = {
  "Kinetic Field":     "#EA580C",
  "Wasteland":         "#B91C1C",
  "Basspod":           "#A16207",
  "Cosmic Meadow":     "#15803D",
  "Stereo Bloom":      "#0E7490",
  "Quantum Valley":    "#1E3A8A",
  "Circuit Grounds":   "#7E22CE",
  "Neon Garden":       "#BE185D",
  "Bionic Jungle":     "#4C1D95",
  "Forest House":      "#365314",
  "YeeDC!":            "#92400E",
  "Insomniac Fridays": "#831843",
};

// EDC-convention word splits (wasteLAND, bassPOD style) for column headers.
// Smaller longest-word ⇒ bigger header text.
export const STAGE_HEADER_WORDS: Record<string, [string, string]> = {
  "Kinetic Field":     ["Kinetic", "Field"],
  "Circuit Grounds":   ["Circuit", "Grounds"],
  "Cosmic Meadow":     ["Cosmic", "Meadow"],
  "Neon Garden":       ["Neon", "Garden"],
  "Basspod":           ["Bass", "Pod"],
  "Wasteland":         ["Waste", "Land"],
  "Quantum Valley":    ["Quantum", "Valley"],
  "Stereo Bloom":      ["Stereo", "Bloom"],
  "Bionic Jungle":     ["Bionic", "Jungle"],
  "Forest House":      ["Forest", "House"],
  "YeeDC!":            ["Yee", "EDC"],
  "Insomniac Fridays": ["Insomniac", "Fridays"],
};

// Short tags for compact contexts (URL params, mobile chips).
export const STAGE_TAG: Record<string, string> = {
  "Kinetic Field":     "KIN",
  "Circuit Grounds":   "CIR",
  "Cosmic Meadow":     "COS",
  "Neon Garden":       "NEO",
  "Basspod":           "BAS",
  "Wasteland":         "WAS",
  "Quantum Valley":    "QUA",
  "Stereo Bloom":      "STE",
  "Bionic Jungle":     "BIO",
  "Forest House":      "FOR",
  "YeeDC!":            "YEE",
  "Insomniac Fridays": "INS",
};
export const TAG_TO_STAGE: Record<string, string> = Object.fromEntries(
  Object.entries(STAGE_TAG).map(([k, v]) => [v, k])
);

export const EDC_MAGENTA = "#ED3895";
export const EDC_CYAN = "#00d9ff";
export const EDC_YELLOW = "#ffae00";
export const FAVORITE_GOLD = "#FBBF24";
